import { httpClient, urlPrefix, makeConfig } from './data'
/**
 * Get list of contacts
 *
 * @param {*} postId
 */
export function list(postId, requestData, param = '') {
  return new Promise((resolve, reject) => {
    let urlPostfix = param ? '/' + param : ''
    httpClient.http
      .post(
        `${urlPrefix}/contacts${urlPostfix}`,
        requestData,
        makeConfig(postId)
      )
      .then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(error)
        }
      )
  })
}

/**
 * Get contact by ID
 *
 * @param {*} postId
 * @param {*} contactId
 */
export function view(postId, contactId) {
  return new Promise((resolve, reject) => {
    httpClient.http
      .get(`${urlPrefix}/contacts/${contactId}`, makeConfig(postId))
      .then(
        response => {
          resolve(response.data.item)
        },
        error => {
          reject(error)
        }
      )
  })
}

/**
 * Create new contact
 *
 * @param {String} postId
 * @param {Object} requestData
 */
export function create(postId, requestData) {
  return new Promise((resolve, reject) => {
    httpClient.http
      .put(`${urlPrefix}/contacts`, requestData, makeConfig(postId))
      .then(
        response => {
          resolve(response.data.id)
        },
        error => {
          reject(error)
        }
      )
  })
}
/**
 * Update contact by ID
 *
 * @param {String} postId
 * @param {String} contactId
 * @param {Object} requestData
 */
export function update(postId, contactId, requestData) {
  return new Promise((resolve, reject) => {
    httpClient.http
      .patch(
        `${urlPrefix}/contacts/${contactId}`,
        requestData,
        makeConfig(postId)
      )
      .then(
        response => {
          resolve(response.data.item)
        },
        error => {
          reject(error)
        }
      )
  })
}

/**
 * Change contact type by ID
 *
 * @param {String} postId
 * @param {String} contactId
 * @param {String} requestData
 * @returns {Promise}
 */
export function changeType(postId, contactId, typeId) {
  const requestData = {
    type_id: typeId
  }
  return httpClient.http
    .patch(
      `${urlPrefix}/contacts/${contactId}/type`,
      requestData,
      makeConfig(postId)
    )
    .then(response => {
      return response.data.item
    })
}



// WEBPACK FOOTER //
// ./src/apps/crm/contacts/api/contacts.js